import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import CreateImportMaps from './CreateImportMaps';
import SpinResolver from '../../../spinResolver/SpinResolver';
import { getImportPermissions, retrieveACHImportMap } from '../../../../api/payments/service';
import useStyles from './CreateImportMaps.styles';

const CreateImportMapsWrapperComponent = (props) => {
  const classes = useStyles();
  const { mapCode, modify } = props;
  const getACHImportMapService = useMemo(
    () => (modify && mapCode ? [() => retrieveACHImportMap(mapCode)] : []),
    [modify, mapCode]
  );

  return (
    <SpinResolver
      services={[getImportPermissions, ...getACHImportMapService]}
      className={classes.contentWrapper}
    >
      {({ results: [importPermissionsData, achImportMapRowData] }) => {
        const importPermissions = get(importPermissionsData, 'data', []);
        const achImportMapData = get(achImportMapRowData, 'data', null);

        if (!importPermissions.length) return null;

        const allowedPermissions = importPermissions.map((permission) => permission.toUpperCase());
        return (
          <CreateImportMaps
            importPermissions={allowedPermissions}
            achImportMapData={achImportMapData}
            {...props}
          />
        );
      }}
    </SpinResolver>
  );
};

CreateImportMapsWrapperComponent.propTypes = {
  modify: PropTypes.bool,
  mapCode: PropTypes.oneOfType([PropTypes.string])
};

CreateImportMapsWrapperComponent.defaultProps = {
  modify: false,
  mapCode: null
};

export default CreateImportMapsWrapperComponent;
